module.exports = __webpack_public_path__ + "files/5ff07d2690b8b4dbbdedbdf1524440a4.png";